import React from 'react';
import { ScannedItemsList } from '../InventoryManagement/components/ScannedItemsList';
import { useScanSessionReview } from './useScanSessionReview';
import { ConfirmModal } from './components/ConfirmModal';
import { BottomBar } from './components/BottomBar';
import './index.css';

const PersonIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="8" r="4" stroke="#6B7280" strokeWidth="1.5" />
    <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const ScanSessionReview = () => {
  const {
    areaName,
    displayItems,
    itemsLoading,
    deleteLoading,
    endLoading,
    showCancelModal,
    showEndModal,
    setShowCancelModal,
    setShowEndModal,
    handleConfirmCancel,
    handleConfirmEnd,
  } = useScanSessionReview();

  return (
    <>
      <div className="ssr-title">
        <h1 className="title">{areaName}</h1>
      </div>
      <div className="ssr-page">
        <div className="ssr-content">
          <div className="ssr-area-section">
            <div className="ssr-area-header">
              <PersonIcon />
              <span className="ssr-area-name">{areaName}</span>
            </div>
            <p className="ssr-scans-count">Scans ({displayItems.length})</p>
            {itemsLoading ? (
              <div className="ssr-items-loading">Loading items...</div>
            ) : (
              <ScannedItemsList scannedItems={displayItems} />
            )}
          </div>
        </div>

        <BottomBar
          onCancel={() => setShowCancelModal(true)}
          onEnd={() => setShowEndModal(true)}
        />

        {showCancelModal && (
          <ConfirmModal
            title="Cancel Session"
            subtitle={"Are you sure you want to cancel session?\nAll unsaved changes will be lost."}
            confirmLabel="Yes, Cancel Session"
            cancelLabel="No, Go Back"
            onConfirm={handleConfirmCancel}
            onCancel={() => setShowCancelModal(false)}
            loading={deleteLoading}
          />
        )}

        {showEndModal && (
          <ConfirmModal
            title="Confirm Session Ending"
            subtitle={"Are you sure you want to end the scanning session?\nYou will no longer be able to edit it."}
            confirmLabel="Yes, End Session"
            cancelLabel="No, keep reviewing the scans"
            onConfirm={handleConfirmEnd}
            onCancel={() => setShowEndModal(false)}
            loading={endLoading}
          />
        )}
      </div>
    </>
  );
};

export default ScanSessionReview;
